import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import floor from 'lodash/floor';

import { currencyCode } from 'Helpers/Geo/data';
import { indexAlgoliaName } from 'Redux/ducks/algolia-calls';
import messages from 'Components/Search/SearchMessages';
import pricing from 'Containers/StaticSearch/games-under-pricing';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';
import BrowseBanner from 'Components/Search/BrowseBanner/BrowseBanner';
import FeaturedTopSellerCarousel from 'Components/OnSale/FeaturedTopSellerCarousel/FeaturedTopSellerCarousel';
import MysteryBundleCardContainer from 'Containers/Cards/MysteryBundleCardContainer';

export default function HybridSaleContent({ pathname }) {
  const { formatMessage, formatNumber } = useIntl();

  const indexName = indexAlgoliaName;

  const priceTagUnder5 = formatNumber(floor(pricing['5'].max[currencyCode] / 100, 2), { minimumFractionDigits: 0, style: 'currency', currency: currencyCode });

  const liveSales = useSelector(state => state.sales.liveSales);
  const majorSale = liveSales.find(sale => sale.majorSale);
  const saleDisplayName = get(majorSale, 'displayName', '');

  const sliderSettings = {
    xs: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    sm: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    md: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    lg: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
    xl: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
    xxl: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  };

  return (
    <>
      <section className="container">
        <FeaturedTopSellerCarousel />
      </section>

      <MysteryBundleCardContainer />

      <section className="container ProductListingPage__browseSection">
        <h2>
          {!saleDisplayName &&
            <FormattedMessage
              id="HybridSaleContent.heading.explore"
              defaultMessage="Explore PC Game Deals"
            />
          }
          {saleDisplayName &&
            <FormattedMessage
              id="HybridSaleContent.heading.explore.sale"
              defaultMessage="Explore the {saleDisplayName}"
              values={{ saleDisplayName }}
            />
          }
        </h2>

        <SiteSlider sliderSettings={sliderSettings} sliderClass="">
          <BrowseBanner
            position="left"
            title={formatMessage(messages.browseGamesUnder, { price: priceTagUnder5 })}
            filter="price=%3A5"
            pathname={pathname}
            backgroundImage={majorSale && 'https://fanatical.imgix.net/production/product/original/c7c43471-b92b-4c0a-9451-3c2892921282.jpeg'}
          />
          <BrowseBanner
            position="center"
            title={formatMessage(messages.browseGameBundles)}
            filter="types=bundle"
            pathname={pathname}
            backgroundImage={majorSale && 'https://fanatical.imgix.net/production/product/original/c7c43471-b92b-4c0a-9451-3c2892921282.jpeg'}
          />
          <BrowseBanner
            position="center"
            title={formatMessage(messages.browseSteamDeckGames)}
            filter="steamdecksupport=verified%2Cplayable"
            pathname={pathname}
            backgroundImage={majorSale && 'https://fanatical.imgix.net/production/product/original/c7c43471-b92b-4c0a-9451-3c2892921282.jpeg'}
          />
          <BrowseBanner
            position="center"
            title={formatMessage(messages.browseMultiplayerGames)}
            filter="features=Multiplayer"
            pathname={pathname}
            backgroundImage={majorSale && 'https://fanatical.imgix.net/production/product/original/c7c43471-b92b-4c0a-9451-3c2892921282.jpeg'}
          />
          <BrowseBanner
            position="right"
            title={formatMessage(messages.browseNewUpcoming)}
            filter={`sortBy=${indexName}_release_date_desc&types=game%2Cdlc`}
            pathname={pathname}
            backgroundImage={majorSale && 'https://fanatical.imgix.net/production/product/original/c7c43471-b92b-4c0a-9451-3c2892921282.jpeg'}
          />
        </SiteSlider>
      </section>
    </>
  );
}

HybridSaleContent.propTypes = {
  pathname: PropTypes.string.isRequired,
};
